import { IReduxState } from 'types/redux';

export const issuesStateSelector = (state: IReduxState) => state.veta.issues;

export const issuesTypesStateSelector = (state: IReduxState) => state.veta.issueTypes;

export const hotIssuesSelector = (state: IReduxState) => state.veta.issues.hot;

export const resolutionTypesSelector = (state: IReduxState) => state.veta.resolutionTypes;
